import { Skeleton } from "@mui/material";
import { PaymentFrequency } from "@repo/api";
import { useTypedTranslation } from "@repo/ui";
import { useMemo } from "react";
import { formatDate, NumberToCZK } from "../../helpers";
import * as Styled from "./PaymentHeader.styled";

export type PaymentHeaderProps = {
    contribution?: number;
    paymentFrequency?: PaymentFrequency | null;
    debt?: number;
    paidToDate?: Date;
    hideDebt?: boolean;
    contributionLabel?: string;
};

export const PaymentHeader: React.FC<PaymentHeaderProps> = ({ contribution, debt, paidToDate, paymentFrequency, hideDebt, contributionLabel }) => {
    const { t } = useTypedTranslation();
    const debtValue = debt ?? undefined;
    const frequencyText = useMemo(() => {
        if (!paymentFrequency) return "";
        return t(`frequencies2.${paymentFrequency}`);
    }, [paymentFrequency, t]);

    return (
        <Styled.PaymentHeaderGrid>
            <Styled.PaymentHeaderTopRow>
                <Styled.PaymentHeaderBodyTextM>
                    {contributionLabel ?? t("life.contractDetail.table.labels.shared.contribution")}
                </Styled.PaymentHeaderBodyTextM>
                <Styled.PaymentHeaderBodyTextM $bold>
                    {contribution !== undefined ? (
                        `${NumberToCZK(contribution)} ${frequencyText}`
                    ) : (
                        <Skeleton width={80} height={32} />
                    )}
                </Styled.PaymentHeaderBodyTextM>
            </Styled.PaymentHeaderTopRow>

            {paidToDate && (
                <Styled.PaymentHeaderTopRow>
                    <Styled.PaymentHeaderBodyTextM>
                        {t("life.contractDetail.table.labels.shared.paidToDate")}
                    </Styled.PaymentHeaderBodyTextM>
                    <Styled.PaymentHeaderBodyTextM $bold>
                        {paidToDate !== undefined ? formatDate(paidToDate, "") : <Skeleton width={80} height={32} />}
                    </Styled.PaymentHeaderBodyTextM>
                </Styled.PaymentHeaderTopRow>
            )}

            {!hideDebt && (
                <Styled.PaymentHeaderTopRow>
                    <Styled.PaymentHeaderBodyTextM>
                        {t("life.contractDetail.table.labels.shared.debt")}
                    </Styled.PaymentHeaderBodyTextM>
                    <Styled.PaymentHeaderBodyTextM $bold $isHighlighted={(debtValue ?? 0) > 0}>
                        {debtValue !== undefined ? NumberToCZK(debtValue) : <Skeleton width={80} height={32} />}
                    </Styled.PaymentHeaderBodyTextM>
                </Styled.PaymentHeaderTopRow>
            )}
        </Styled.PaymentHeaderGrid>
    );
};
